import { StateCreator } from 'zustand';
import {
	createTableManagerStoreSliceFactory,
	PaginatorStore,
	TableManagerStore,
	tableManagerStoreSelector,
} from '@warehouse/shared/ui';
import { ChildrenColumnName } from '../children-sort';

export interface ChildrenTableManagerStore extends TableManagerStore<ChildrenColumnName> {}

interface FactoryOptions {
	getPaginatorStore: () => PaginatorStore;
}

export const createChildrenTableManagerSliceFactory =
	({ getPaginatorStore }: FactoryOptions): StateCreator<ChildrenTableManagerStore> =>
	(set, get, store) => {
		const tableManagerStore = createTableManagerStoreSliceFactory<ChildrenColumnName>({ getPaginatorStore })(
			set,
			get,
			store,
		);

		return {
			...tableManagerStore,
			actions: {
				...tableManagerStore.actions,
			},
		};
	};

export const childrenTableTableManagerSelector = {
	...tableManagerStoreSelector,
	actions: (state: ChildrenTableManagerStore) => ({
		...tableManagerStoreSelector.actions(state),
	}),
};
